export class toggleCategory {
    id: string;
    open: boolean;
    constructor(id,open) {
        this.id = id;
        this.open = open;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/toggle-category.ts